import { GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'
import { getServerSideProps as getServerSidePropsDefault, default as SearchDefaultPage } from './Default'
import { getServerSideProps as getServerSidePropsAlt, default as SearchAlternativePage } from './Alternative'
import withError from '../../components/withError'
import { useFeatureFlags, getFeatureFlags } from '../../hooks/useFeatureFlags'
import { SearchPageProps } from '../../types'
import { ONE_WEEK_CACHE_AGE, TENANTS } from '../../constants/global'
import { withSSRPropsMocks } from '../../playwright/utils/withMockingProps'

const SearchPage = (props: SearchPageProps) => {
  const { locale } = useRouter()
  const { alternativeSearchEnabled } = useFeatureFlags()

  if (alternativeSearchEnabled && locale !== TENANTS.WPA) {
    return <SearchAlternativePage {...props} />
  }

  return <SearchDefaultPage {...props} />
}

export const getServerSideProps = withSSRPropsMocks(async (context: GetServerSidePropsContext) => {
  const { locale } = context
  const { alternativeSearchEnabled } = getFeatureFlags()

  context.res.setHeader('Cache-Control', `max-age=${ONE_WEEK_CACHE_AGE}`)

  if (alternativeSearchEnabled && locale !== TENANTS.WPA) {
    return getServerSidePropsAlt(context)
  }

  return getServerSidePropsDefault(context)
}, 'find/:search')

const SearchPageWitError = withError<SearchPageProps>(SearchPage)

export default SearchPageWitError
